/*
 * @Author: your name
 * @Date: 2021-10-25 15:23:34
 * @LastEditTime: 2023-03-28 10:16:30
 * @LastEditors: OBKoro1
 * @Description: In User Settings Edit
 * @FilePath: \ngtc-traceability-admin\src\app\pages\user\user.service.ts
 */
import { http } from '../../utils/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserInfo } from './models/user-info';
import { UserThirdInfo } from './models/user-third-info';
import PagedResult from 'src/app/utils/pagedResult';

const platformNameMap = {
    '1': '微信',
    '2': '微博',
} as any;

interface userPermissions {
    userId: string,
    permissions: Array<string>
}
interface userDataPermissions {
    UserID: string, //当前选择的用户
    DataType: "", //1：应用,2：渠道
    Datas: [
        {
            DataID: "",//应用或者渠道得ID
            DataName: ""//应用或者渠道得名称
        }
    ];
}
@Injectable()
export class UserService {

    constructor(private http: http) { }
    pagedList(filter: any): Observable<any> {
        return this.http.post('user/page', filter);
    }

    loginlogPageList(filter: any): Observable<any> {
        return this.http.post('user/logUser/page', filter);
    }

    operationlogPageList(filter: any): Observable<any> {
        return this.http.post('sys/logView', filter);
    }

    add(user: UserInfo): Observable<any> {
        return this.http.post('user/add', user);
    }

    delete(id: string): Observable<any> {
        return this.http.delete(`user/delete?id=${id}`);
    }

    get(id: string): Observable<any> {
        return this.http.get(`user/get?id=${id}`);
    }


    save(user: UserInfo) {
        return this.http.post('user/save', user);
    }

    getUserProfile() {
        return this.http.get('account/profile');
    }

    personalBindPhone(phone: string, code: string) {
        return this.http.post('account/personalBindPhone', { phone, code });
    }

    personalUnbindThird(thirdId: string) {
        return this.http.post('account/personalUnbindThird', { thirdId });
    }

    personalChangePassword(newPassword: string, oldPassword: string) {
        return this.http.post('account/personalChangePassword', { newPassword, oldPassword });
    }

    getUserPermissions() {
        return this.http.get('sys/getUserPermissions');
    }
    getSysPermissions() {
        return this.http.get('sys/getPermissions')
    }

    saveUserPermissions(user: userPermissions) {
        return this.http.post('sys/saveUserPermissions', user)
    }
    saveUserDataPermissions(user: userDataPermissions) {
        return this.http.post('sys/saveUserDataPermissions', user)

    }
    getPermissions(id: any) {
        return this.http.get(`sys/getUserPermissions?id=${id}`)
    }
    getUserDataPermissions(id: any, dataType: any) {
        return this.http.get(`sys/getUserDataPermissions?userId=${id}&dataType=${dataType}`)
    }
    changePassword(data: {  oldPassword: string, newPassword: string }): Observable<any> {
        return this.http.post('user/passwordUpdate', data);
    }

    resetPassword(data: {   newPassword: string,userId:string }): Observable<any> {
        return this.http.post('user/passwordReset', data);
    }

    upload(form: FormData): Observable<any> {
        return this.http.post('file/upload', form);
    }
}
